import React from "react"
import { useState } from "react"
import addToMailchimp from "gatsby-plugin-mailchimp"
import { AiOutlineWarning } from "react-icons/ai"

export const Newsletter = (props) => {
  const [email, setEmail] = useState("")
  const [msg, setMsg] = useState()
  const [err, setErr] = useState()
  const handleSubmit = (e) => {
    e.preventDefault()
    addToMailchimp(email).then((data) => {
      return data.result === "success"
        ? setMsg(data.msg)
        : setErr(
            "There was a problem with getting you subscribed or maybe you are already subscribed with this email? Please try with another one!"
          )
    })
  }
  const handleChange = (e) => {
    setEmail(e.target.value)
  }

  const reset = () => {
    setEmail("")
    setMsg(null)
    setErr(null)
  }
  const { lightBg, className, ...rest } = props

  if (!process.env.GATSBY_MAILCHIMP_ENDPOINT) return null

  return (
    <div {...rest}>
      <div
        className={`shadow-xl rounded-xl text-white bg-slate-800 dark:bg-slate-900 flex flex-col self-start py-4 px-2 mb-12 ${className}`}
      >
        {msg ? (
          <div className="max-w-[500px] mx-auto w-full text-center px-2">
            <p className="mb-2 text-3xl">🙏</p>
            <p className="text-base">{msg}</p>
          </div>
        ) : err ? (
          <div className="max-w-[500px] mx-auto w-full text-center px-2">
            <AiOutlineWarning className="mx-auto text-3xl mb-2" />
            <p className="mb-4 text-base">{err}</p>
            <button style={buttonStyling} onClick={reset}>
              Try again
            </button>
          </div>
        ) : (
          <>
            <p className="text-2xl font-heading text-center lg:max-w-[300px] mx-auto my-4">
              Useful front-end & UX tips, delivered once a week.
            </p>

            {/* Email Input */}
            <div className="max-w-[500px] mx-auto w-full">
              <form className="mx-2 flex flex-col mb-3" onSubmit={handleSubmit}>
                <div className="w-full mb-4">
                  <input
                    placeholder="Email address"
                    name="email"
                    // type="email"
                    required
                    value={email}
                    className="rounded-md w-full h-10 px-5 border-0 rounded-none bg-nlInputBg dark:bg-dark-nlInputBg text-nlColor dark:text-dark-nlColor focus:outline-none focus:ring-1 focus:ring-primary dark:focus:ring-opacity-40 focus:ring-inset"
                    onChange={handleChange}
                    aria-label="Add your Email address to subscribe"
                  />
                </div>

                <div className="w-full">
                  <button
                    type="submit"
                    className="hover:underline h-10 w-full btn bg-nlButtonBg dark:bg-dark-nlButtonBg dark:text-dark-nlButtonColor hover:bg-nlButtonHoverBg dark:hover:bg-dark-nlButtonHoverBg"
                    style={buttonStyling}
                  >
                    Subscribe
                  </button>
                </div>
              </form>
            </div>

            <p className="mb-4 text-center text-base">
              Useful front-end & UX tips, delivered once a week. 🎁
            </p>
          </>
        )}
      </div>
    </div>
  )
}

const buttonStyling = {
  borderRadius: "5px",
  paddingLeft: "20px",
  paddingRight: "20px",
  paddingTop: "5px",
  paddingBottom: "5px",
  display: "block",
  width: "100%",
  border: "none",
  cursor: "pointer",
  backgroundColor: "var(--theme-ui-colors-primary,rgb(137,25,248))",
  color: "var(--theme-ui-colors-white,white)",
  textTransform: "uppercase",
  fontSize: "0.875rem",
  fontWeight: "700",
  WebkitLetterSpacing: "1.2px",
  MozLetterSpacing: "1.2px",
  MsLetterSpacing: "1.2px",
  letterSpacing: "1.2px",
  backgroundImage:
    "linear-gradient(60deg,var(--theme-ui-colors-primary,rgb(137,25,248)),var(--theme-ui-colors-pink,rgb(230,74,145)))",
}
